import $ from 'jquery';
window.$ = window.jQuery = $;
import { select2 } from 'select2';

import Parallax from 'parallax-js';
// import 'is-in-viewport';
const Cleave = require('cleave.js');
const CleaveFormat = require('../../node_modules/cleave.js/dist/addons/cleave-phone.ua.js');


$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

class MELAPIS {
    constructor() {
        this.mobileNav();
        this.parallax();
        this.bgParallax();
        this.googleMap();
        this.customAnchorsInit();
        this.productModal();
        this.animateCss();
        this.select();
        this.cleave();
    }

    cleave() {
        $('.phone-input input').each(function() {
            var cleave = new Cleave($(this), {
            prefix: '+38',
            phone: true,
            phoneRegionCode: 'ua'
        });
        })
        
    }

    select() {
        $('select').select2();
    }

    viewport() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width : parseInt(e[ a+'Width' ]) , height : parseInt(e[ a+'Height' ])};
    }

    animateCss() {
        let self = this;
        var $el = $('.js-animate');

        function animate() {
            if (self.viewport().width > 768) {
                $el.each(function() {
                    let animation = $(this).data('animation');
                    if ($(this).isInViewport()){
                        $(this).addClass('animated ' + animation);
                    } else {
                        $(this).removeClass('animated ' + animation);
                    }
                })
            }
        }

        animate();
        $(window).on('load resize scroll',  () => {animate()});
    }

    bgParallax() {
        var $el = $('.parallax-background');
        $(window).on('load resize scroll',  () => {
            if (this.viewport().width > 992) {
                var scroll = $(document).scrollTop();
                $el.each(function() {
                    let offset = $(this).data('offset');
                    $(this).isInViewport() && $(this).css({
                        'background-position':'50% '+(-.2*scroll - offset)+'px'
                    });
                })
            }else {
                $el.each(function() {
                    $(this).css({
                        'background-position':'50% 50%'
                    });
                })
            }

        });
    }

    customAnchorsInit() {
        let menuElm = $('#menu');
        var menuHeight = menuElm.height();
        $('.link').each(function () {
            var a = $(this);
            var destination = a.data('target');
            var lang = $('html').attr('lang');

            if (destination){
                a.on('click', function(){
                    if (window.location.pathname == "/uk/" || window.location.pathname == "/"){
                        var selector = '.' + destination + '.section';
                        if ($(selector).length > 0){

                            $('html, body').animate({
                                scrollTop: $(selector).offset().top - 50
                            }, 500);

                        }


                    }else {
                        if (lang !== 'en-GB'){
                            window.location.href = `/${lang}/#${destination}`;
                        } else {
                            window.location.href = `/#${destination}`;
                        }
                    }



                    if ($('.menu').hasClass('is-active')){
                        $('body, html').toggleClass('no-overflow');
                        $('.site-box').toggleClass('blured');
                        $('.open-mobile-nav ').toggleClass('is-active');
                        $('.menu').toggleClass('is-active');
                    }
                });
            }
        });
    };

    productModal() {
        $('.toggle-product-modal').on('click', (event) => {
            $('body, html').toggleClass('no-overflow');
            $(`.${ $(event.currentTarget).data('modal') }`).toggleClass('is-active');
        });
    }

    parallax() {
        var scene = $('.scene');
        scene.each(key => {
            var parallaxInstance = new Parallax(scene[key], {
                relativeInput: true,
                hoverOnly: true
            });
        })
    }

    mobileNav() {
        $('.open-mobile-nav ').on('click', function () {
            $('body, html').toggleClass('no-overflow');
            $('.site-box').toggleClass('blured');
            $(this).toggleClass('is-active');
            $('.menu').toggleClass('is-active');
        });
    };


    googleMap() {
        if ($('#map').length > 0){
            function initialize() {
                var position = {
                    lat: 50.427904,
                    lng: 30.518654
                };
                var mapCanvas = document.getElementById('map');
                var mapOptions = {
                    center: new google.maps.LatLng(position.lat + 0.0008, position.lng),
                    zoom: 15,
                    disableDefaultUI: true,
                    zoomControl: true,
                    zoomControlOptions: {
                        position: google.maps.ControlPosition.LEFT_BOTTOM
                    },
                    styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    navigationControl: false,
                    mapTypeControl: false,
                    scaleControl: false
                };
                var map = new google.maps.Map(mapCanvas, mapOptions)
                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: 'Paradise Capital'
                });
                var url = window.location.hostname;
                marker.setIcon('/wp-content/themes/melapis/assets/img/map-marker.png');
            }
            initialize();
        }
    };
}

window.onload = () => {
    let app = new MELAPIS();
    // setTimeout(function () {
    //     $('.preloader').fadeOut(500);
    // }, 1500);
}



// WEBPACK FOOTER //
// ./assets/js/index.js